export default __webpack_public_path__ + "static/ssc-home-1509a07bd75d228630e3f074b53d7097.png";